<template>
  <div class="library-page">
    <!-- 顶部导航 -->
    <!-- <AppHeader /> -->

     <!-- 1. Banner 区域 (深色) -->
    <section class="lib-banner">
      <div class="banner-overlay"></div>
      <div class="container">
        <div class="banner-content">
          <h1>AI数字人<br>图书检索系统</h1>
          <p class="subtitle">找书更快，阅读更好</p>
          <button class="btn-primary" @click="contactUs">
            合作咨询 <span class="divider">|</span> 020-82038386
          </button>
        </div>
      </div>
    </section>

    <!-- 2. 核心功能 (白色背景) -->
     <!-- 2. 核心功能 (白色背景) -->
   <section class="lib-features">
  <div class="container">
    <div class="section-title">
      <h2>核心功能</h2>
    </div>
    <div class="features-grid">
      <div class="feature-card" v-for="item in features" :key="item.id">
        <!-- 1. 标题在最上方 -->
        <h4>{{ item.title }}</h4>
        
        <!-- 2. 中间是大的虚线框图片区域 -->
        <div class="image-box">
          <!-- 动态引入图片 -->
          <img :src="item.image" loading="lazy" :alt="item.title" class="feature-img">
        </div>
        
        <!-- 3. 底部描述 -->
        <p>{{ item.desc }}</p>
      </div>
    </div>
  </div>
</section>

    <!-- 3. 软硬件一体化终端 (浅灰背景) -->
   <section class="lib-terminal">
  <div class="container">
    <div class="section-title">
      <h2>软硬件一体化终端</h2>
      <p class="subtitle">专为智慧图书馆打造的智能终端设备</p>
    </div>
    
    <div class="terminal-layout">
      <!-- 左侧：设备图片 (带虚线框) -->
      <div class="terminal-device">
        <div class="image-wrapper">
          <!-- 请替换为实际的设备图片路径 -->
          <img src="../assets/images/Frame 427319259.png" loading="lazy" alt="智能终端设备" class="device-img">
        </div>
      </div>

      <!-- 右侧：功能列表 -->
      <div class="terminal-features">
        
        <!-- 功能 1 -->
        <div class="tf-item">
          <div class="tf-icon-box">
            <!-- 请替换为 HD 图标 -->
            <img src="../assets/images/screen-icon.png" alt="HD" class="tf-icon-img">
          </div>
          <div class="tf-content">
            <strong>高清触控大屏</strong>
            <p>23.8英寸高清触控屏，交互流畅，视觉体验出色。</p>
          </div>
        </div>

        <!-- 功能 2 -->
        <div class="tf-item">
          <div class="tf-icon-box">
            <!-- 请替换为 屏幕/系统 图标 -->
            <img src="../assets/images/icon-touch.png" alt="系统" class="tf-icon-img">
          </div>
          <div class="tf-content">
            <strong>AI交互系统</strong>
            <p>内置AI语音识别与语义理解引擎，快速响应，更懂用户。</p>
          </div>
        </div>

        <!-- 功能 3 -->
        <div class="tf-item">
          <div class="tf-icon-box">
            <!-- 请替换为 稳固/工业 图标 -->
            <img src="../assets/images/icon-stable.png" alt="工业" class="tf-icon-img">
          </div>
          <div class="tf-content">
            <strong>工业设计</strong>
            <p>稳定耐用，7×24小时运行，适应图书馆高强度使用场景。</p>
          </div>
        </div>

        <!-- 功能 4 -->
        <div class="tf-item">
          <div class="tf-icon-box">
            <!-- 请替换为 语音/声波 图标 -->
            <img src="../assets/images/icon-voice.png" alt="语音" class="tf-icon-img">
          </div>
          <div class="tf-content">
            <strong>语音识别</strong>
            <p>支持语音交互，集成麦克风阵列，远场语音识别更精准。</p>
          </div>
        </div>

        <!-- 功能 5 -->
        <div class="tf-item">
          <div class="tf-icon-box">
            <!-- 请替换为 工具/部署 图标 -->
            <img src="../assets/images/install-icon.png" alt="部署" class="tf-icon-img">
          </div>
          <div class="tf-content">
            <strong>灵活部署</strong>
            <p>支持壁挂、立式等多种安装方式，适配各类空间环境。</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- 4. 产品优势 (极淡背景) -->
<!-- <section class="lib-advantages">
  <div class="container">
    <div class="section-title">
      <h2>产品优势</h2>
    </div>
    <div class="adv-grid">
      <div class="adv-item" v-for="adv in advantages" :key="adv.id">
        <h4>{{ adv.title }}</h4>
        <p>{{ adv.desc }}</p>
      </div>
    </div>
  </div>
</section> -->

<!-- 5. 应用场景 (白色背景) -->
<!-- <section class="lib-scenarios">
  <div class="container">
    <div class="section-title">
      <h2>应用场景</h2>
    </div>
    <div class="scenarios-grid">
      <div class="scenario-card" v-for="scene in scenarios" :key="scene.id">
        <div class="scenario-img-box">
      
          <img :src="scene.img" :alt="scene.title" class="scene-img">
        </div>
        <div class="scenario-info">
          <h4>{{ scene.title }}</h4>
          <p>{{ scene.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</section> -->

    <!-- 底部 -->
    <AppFooter />

    <!-- 悬浮返回按钮 -->
    <button class="back-btn" @click="goBack">← 返回首页</button>
  </div>
</template>

<script>
// import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'AILibrarySearch',
  components: {  AppFooter },
  data() {
    return {
      features: [
      {
        id: 1,
        title: 'AI数字人引导',
        // 引入对应的卡通人物图片
        image: require('../assets/images/feature-ai-guide.png'), 
        desc: '拟人化AI数字人形象，亲切自然的交互体验，引导用户轻松完成检索。'
      },
      {
        id: 2,
        title: '语音检索',
        // 引入聊天界面截图
        image: require('../assets/images/feature-voice-search.png'),
        desc: '支持语音输入，自然语言理解，快速准确匹配书籍资源。'
      },
      {
        id: 3,
        title: '智能书籍推荐',
        // 引入书籍封面图
        image: require('../assets/images/feature-book-rec.png'),
        desc: '基于用户兴趣与借阅数据，智能推荐相关书籍，发现更多好书。'
      },
      {
        id: 4,
        title: '数据可视化管理',
        // 引入数据图表图
        image: require('../assets/images/feature-data-viz.png'),
        desc: '后台数据可视化，助力馆方优化资源配置与读者服务。'
      }
    ],
      terminalFeatures: [
        { title: '高清触控屏，响应灵敏，显示清晰' },
        { title: '内置高性能处理器，运行流畅稳定' },
        { title: '集成麦克风阵列，远场语音识别更精准' },
        { title: '模块化设计，安装维护便捷' },
        { title: '支持定制化开发，满足个性化需求' }
      ],
     advantages: [
      { id: 1, title: 'AI赋能', desc: '先进的人工智能技术，持续学习与优化，越用越懂你。' },
      { id: 2, title: '精准高效', desc: '毫秒级检索响应，精准定位，节省时间提升效率。' },
      { id: 3, title: '资源整合', desc: '打通馆内外资源，一站式检索，全面获取知识。' },
      { id: 4, title: '易用友好', desc: '界面简洁，操作便捷，老少皆宜，无障碍使用。' },
      { id: 5, title: '安全可靠', desc: '数据安全保障，系统稳定可靠，7×24小时服务。' }
    ],
    scenarios: [
      { 
        id: 1, 
        title: '中小学图书馆', 
        desc: '培养阅读兴趣，助力学生自主学习。',
        img: require('@/assets/images/scene-school.png') // 替换为真实路径
      },
      { 
        id: 2, 
        title: '高校图书馆', 
        desc: '提升服务效率，优化读者体验，打造智慧化学习空间。',
        img: require('@/assets/images/scene-university.png')
      },
      { 
        id: 3, 
        title: '公共图书馆', 
        desc: '智能化服务升级，让知识触手可及。',
        img: require('@/assets/images/scene-public.png')
      },
      { 
        id: 4, 
        title: '企业/机构图书馆', 
        desc: '高效知识管理，赋能组织学习与创新。',
        img: require('@/assets/images/scene-enterprise.png')
      }]
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
    },
    contactUs() {
      alert('联系电话：020-82038386')
    }
  }
}
</script>

<style scoped>
.container { 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

/* 1. Banner (深色背景图) */
.lib-banner {
  position: relative;
  /* 左侧深色背景，与图片左侧暗部融合 */
  background-color: #0a0a0a;
  background-image: url('../assets/images/library-banner-bg.png');
  /* 高度填满容器，宽度自动按比例缩放 */
  background-size: auto 100%;
  /* 靠右对齐，确保右侧主体（设备/人物）完整显示 */
  background-position: right center;
  background-repeat: no-repeat;
  color: #fff;
  padding: 0;
  height: 750px; /* 固定高度，不占满屏幕 */
  display: flex;
  align-items: center;
  overflow: hidden;
}

/* 渐变遮罩：左侧深色保护文字，右侧透明显示主体 */
.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to right, 
    #0a0a0a 0%, 
    #0a0a0a 25%,
    rgba(10, 10, 10, 0.85) 40%,
    rgba(10, 10, 10, 0.4) 55%,
    transparent 70%
  );
  z-index: 1;
}

.lib-banner .container { 
  display: flex; 
  align-items: center; 
  justify-content: flex-start;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 5%;
  position: relative;
  z-index: 2;
}

.banner-content { 
  max-width: 550px; /* 限制文字区域宽度 */
}

.banner-content h1 { 
  font-size: 52px; 
  line-height: 1.2; 
  margin-bottom: 20px; 
  font-weight: bold;
  color: #fff;
}

.subtitle { 
  font-size: 22px; 
  color: rgba(255, 255, 255, 0.9); 
  margin-bottom: 36px; 
  font-weight: 500;
}

.btn-primary { 
  background: #10b1f2; 
  color: #fff; 
  border: none; 
  padding: 14px 32px;
  border-radius: 24px; 
  font-size: 16px; 
  cursor: pointer; 
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.btn-primary:hover { 
  background: #1557b0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4);
}

.divider {
  opacity: 0.6;
  margin: 0 4px;
}

/* 响应式 */
@media (max-width: 1200px) {
  .lib-banner {
    height: 500px;
  }
  .banner-content h1 { font-size: 44px; }
}

@media (max-width: 992px) {
  .lib-banner {
    height: 450px;
  }
  .banner-content h1 { font-size: 36px; }
  .subtitle { font-size: 18px; }
  /* 平板端加深遮罩，防止文字看不清 */
  .banner-overlay {
    background: rgba(10, 10, 10, 0.9);
  }
}

@media (max-width: 768px) {
  .lib-banner {
    height: 400px;
  }
  .banner-content h1 { font-size: 28px; }
  .subtitle { font-size: 16px; }
}
/* 2. Features */
.lib-features { 
  padding: 80px 0; 
  background: #f6fafc;
}

.section-title { 
  text-align: center; 
  margin-bottom: 50px; 
}

.section-title h2 { 
  font-size: 32px; 
  color: #1e293b; 
  margin-bottom: 10px;
  font-weight: bold;
}

.features-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 24px; 
}

.feature-card {
  background: #fff; 
  padding: 24px 20px; /* 调整内边距 */
  border-radius: 12px;
  text-align: center; 
  /* 图片中卡片似乎有轻微的阴影或边框，这里加一个淡边框 */
  border: 1px solid #f1f5f9; 
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); /* 轻微阴影增加立体感 */
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feature-card:hover { 
  transform: translateY(-5px); 
  box-shadow: 0 10px 25px rgba(0,0,0,0.1); 
}

.feature-card h4 { 
  margin-bottom: 20px; 
  color: #1e293b; 
  font-size: 18px; /* 标题稍微大一点 */
  font-weight: 600;
  width: 100%;
}

/* --- 核心修改：虚线框容器 --- */
.image-box {
  width: 100%;
  height: 180px; /* 固定高度，确保卡片整齐 */
  margin-bottom: 20px;
  /* 虚线边框样式 */
  /* border: 1px dashed #cbd5e1;  */
  background-color: #f8fafc; /* 极浅的灰蓝色背景 */
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 10px; /* 给图片留点边距 */
  box-sizing: border-box;
}

.feature-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* 保持图片比例，完整显示 */
}

.feature-card p { 
  font-size: 13px; 
  color: #64748b; 
  line-height: 1.6;
  margin: 0;
  flex-grow: 1; /* 让文字区域撑开，保证底部对齐（如果需要） */
}

/* 响应式调整 */
@media (max-width: 992px) {
  .features-grid { 
    grid-template-columns: repeat(2, 1fr); 
  }
}

@media (max-width: 576px) {
  .features-grid { 
    grid-template-columns: 1fr; 
  }
  .image-box {
    height: 220px; /* 手机端图片区域可以更高一点 */
  }
}
/* 3. Terminal (浅灰) */
.lib-terminal { 
  padding: 80px 0; 
  background: #ffffff; 
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title { 
  text-align: center; 
  margin-bottom: 60px; 
}

.section-title h2 { 
  font-size: 32px; 
  color: #0f172a; 
  margin-bottom: 12px;
  font-weight: bold;
  margin-top: 0;
}

.section-title .subtitle {
  font-size: 16px;
  color: #475569; 
  margin: 0;
}

/* 布局调整：左图右文 */
.terminal-layout { 
  display: flex; 
  align-items: center; /* 垂直居中 */
  justify-content: space-between;
  gap: 60px; 
  max-width: 1200px; /* 限制最大宽度，让布局更紧凑 */
  margin: 0 auto;
}

/* 左侧设备区域 */
.terminal-device { 
  flex: 1; 
  display: flex; 
  justify-content: center;
}

/* 图片外围的大虚线框 */
.image-wrapper {
  position: relative;
  /* border: 1px dashed #cbd5e1;  */
  border-radius: 12px;
  /* padding: 40px;  */
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.device-img {
  max-width: 100%;
  height: auto;
  max-height: 500px; /* 限制高度 */
  display: block;
  /* 去掉圆角，保持原图样式，或者根据需要添加 */
}

/* 右侧功能列表区域 */
.terminal-features { 
  flex: 1; 
  max-width: 500px;
}

.tf-item {
  display: flex; 
  align-items: flex-start; 
  gap: 20px; 
  margin-bottom: 32px; /* 增加间距 */
}

.tf-item:last-child {
  margin-bottom: 0;
}

/* 小图标容器：带虚线框 */
.tf-icon-box {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  /* border: 1px dashed #3b82f6;  */
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  margin-top: 2px; /* 微调对齐 */
}

.tf-icon-img {
  width: 38px; /* 图标大小 */
  height: 38px;
  object-fit: contain;
  margin-top: 10px;
  /* 如果原图是黑色的，可以用 filter 变蓝 */
  /* filter: invert(43%) sepia(93%) saturate(1352%) hue-rotate(176deg) brightness(90%) contrast(95%); */
}

.tf-content {
  flex: 1;
}

.tf-content strong {
  display: block;
  color: #1e293b;
  font-size: 18px; /* 标题加大 */
  font-weight: bold;
  margin-bottom: 6px;
}

.tf-content p {
  color: #64748b;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

/* 响应式 */
@media (max-width: 992px) {
  .terminal-layout {
    flex-direction: column; /* 小屏幕上下排列 */
    gap: 50px;
  }
  
  .terminal-device {
    width: 100%;
  }
  
  .terminal-features {
    width: 100%;
    max-width: 100%;
  }
}

/* 4. Advantages (极淡蓝灰背景) */
.lib-advantages { 
  padding: 80px 0; 
  background: #f8fafc; /* 极淡的背景色 */
}

.adv-grid { 
  display: grid; 
  grid-template-columns: repeat(5, 1fr); 
  gap: 30px; 
}

.adv-item {
  text-align: center;
  padding: 10px;
}

.adv-item h4 { 
  margin-bottom: 12px; 
  color: #1e293b; 
  font-size: 18px; 
  font-weight: bold;
}

.adv-item p { 
  font-size: 13px; 
  color: #64748b; 
  line-height: 1.6; 
}

/* 5. Scenarios (白色背景) */
/* 5. Scenarios (白色背景) */
.lib-scenarios { 
  padding: 80px 0; 
  background: #fff; 
}

/* .section-title {
  text-align: center;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 32px;
  color: #1e293b;
  font-weight: bold;
  margin: 0;
} */

.scenarios-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.scenario-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.scenario-card:hover {
  transform: translateY(-5px);
}

/* 图片区域 */
.scenario-img-box {
  height: 200px;
  overflow: hidden;
  background: #f1f5f9;
}

.scene-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.scenario-card:hover .scene-img {
  transform: scale(1.05);
}

/* 文字信息区域 (浅蓝色背景) */
.scenario-info {
  background: #f0f7ff; /* 浅蓝色背景 */
  padding: 25px 20px;
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.scenario-info h4 { 
  margin: 0 0 12px 0; 
  color: #1e293b; 
  font-size: 18px; 
  font-weight: 600;
  line-height: 1.3;
}

.scenario-info p { 
  font-size: 14px; 
  color: #64748b; 
  line-height: 1.6; 
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 1400px) {
  .scenarios-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .lib-scenarios {
    padding: 60px 0;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
  
  .scenarios-grid {
    grid-template-columns: 1fr;
    max-width: 500px;
  }
  
  .scenario-img-box {
    height: 220px;
  }
  
  .scenario-info h4 {
    font-size: 17px;
  }
  
  .scenario-info p {
    font-size: 13px;
  }
}
/* 返回按钮 */
.back-btn {
  position: fixed; bottom: 30px; right: 30px;
  background: #1e293b; color: #fff; border: none;
  padding: 15px 30px; border-radius: 30px;
  cursor: pointer; box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  z-index: 1000; font-size: 16px;
}
.back-btn:hover { background: #334155; }
</style>